import { create } from "zustand";
import { UserInfoCurrent } from "../../api-client";

interface UserInfoInterface {
  userInfo: UserInfoCurrent | undefined;
  setUserInfo: (value: UserInfoCurrent | undefined) => void;
  userHasScope: (scope: string) => boolean;
  pathUrl: (path: string) => string;
  documentUrl: (
    docType: string | undefined | null,
    docId: string | undefined | null
  ) => string ;
}

export const useUserInfoStore = create<UserInfoInterface>((set, get) => ({
  userInfo: undefined,
  setUserInfo: (value: UserInfoCurrent | undefined) => set({ userInfo: value }),
  userHasScope: (scope: string): boolean => {
    const userInfo = get().userInfo;
    if (!userInfo || !userInfo.scopes) return false;
    return userInfo.scopes.includes(scope);
  },
  documentUrl: (
    docType: string | undefined | null,
    docId: string | undefined | null
  ): string  => {
    if (!docType || !docId) return "";
    const userInfo = get().userInfo;
    if (!userInfo || !userInfo.organization) return "";
    const orgUrl = userInfo.organization.appUrl?.endsWith("/")
      ? userInfo.organization.appUrl.slice(0, -1)
      : userInfo.organization.appUrl;
    return `${orgUrl}/go/${docType}/${docId}`;
  },
  pathUrl: (path: string): string => {
    const userInfo = get().userInfo;
    if (!userInfo || !userInfo.organization) return path;
    const orgUrl = userInfo.organization.appUrl?.endsWith("/")
      ? userInfo.organization.appUrl.slice(0, -1)
      : userInfo.organization.appUrl;

    if (path.startsWith("/")) {
      path = path.substring(1);
    }
    return `${orgUrl}/${path}`;
  },
}));
